import {implementationName} from "../../../metl-models/util/ComponentMap.ts";
import type {SharedJobRow} from "../../../components/scanner/shared-job-scanner/SharedJobData.tsx";
import Styles from "./ComponentList.module.scss"

interface Props {
    components: Record<number, number>
    sharedJobs?: SharedJobRow[]
}
export function ComponentList({components, sharedJobs}: Props) {
    const sortedEntries = Object.entries(components).sort((a, b) => b[1] - a[1])

    return <div className={Styles.ComponentList}>
        <table>
            <thead>
                <tr>
                    <th>Component</th>
                    <th>Number</th>
                </tr>
            </thead>
            <tbody>
                {sortedEntries.map(([component, count]) => (
                    <tr key={component}>
                        <td>{implementationName(parseInt(component), sharedJobs)}</td>
                        <td>{count}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
}